
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { IconButton, Typography } from 'foundations-library/components'
import { useHistory, useLocation } from 'react-router-dom'
import { getVerbalColors } from 'helpers'
import { useAppContext } from './../contexts/AppContext'

const useStyles = makeStyles(theme => {
    const { colors } = theme['foundations-library']
    const verbalColors = getVerbalColors(colors)

    return {
        root: {
            display: 'flex',
            backgroundColor: verbalColors['neutral-50'],
            height: '54px',
            alignItems: 'center',
            paddingLeft: '10px',
            gap: '12px',
            '& .delimiter': {
                width: '1px',
                height: '24px',
                backgroundColor: verbalColors['neutral-100']
            }
        }

    }
})

/**
 *
 */
const GoBack = ({ title }: { title?: string }): JSX.Element => {
    const classes = useStyles()

    const history = useHistory()
    const location = useLocation()

    const [hashCount, setHashCount] = useState(0)
    const [currentHash, setCurrentHash] = useState(location.hash)

    const { app } = useAppContext()

    useEffect(() => {
        if (location.hash) {
            if (location.hash === currentHash) return

            setHashCount(c => c + 1)
            setCurrentHash(location.hash)
        } else {
            setHashCount(0)
            setCurrentHash('')
        }
    }, [location])

    const handleGoBack = () => {
        history.go(-1 - hashCount)
    }

    return (
        <div className={classes.root}>
            <IconButton name='back' variant='icon' color='neutral' size='small' onMouseUp={handleGoBack} data-testid='back-btn' />
            <div className='delimiter' />
            <Typography variant='h8' color='neutral-900'>{title || app.title}</Typography>
        </div>
    )
}

export default GoBack
